import React from 'react'
import { useNavigate } from 'react-router-dom'

import { ButtonClean, Icon, useModalContext } from '@fourthwall/components'
import { CloseIcon } from '@fourthwall/icons'
import { isWebView } from '@fourthwall/utils'
import { useFormikContext } from '@fourthwall/utils/dist/formik'
import { routing } from '@utils/routing'

import { SeriesCell } from '../../../Series/components/SeriesCell'
import { useSeries } from '../../hooks/useSeries'
import type { FormValues } from '../../types'
import { FormFields } from '../../types'
import { SelectSeries } from '../SelectSeries'
import { EmptyModal } from './EmptyModal'
import * as S from './styled'

type Props = {
  disabled?: boolean
}

export const SeriesFields = ({ disabled }: Props) => {
  const modal = useModalContext()
  const { values, setFieldValue } = useFormikContext<FormValues>()
  const { series } = useSeries()
  const navigate = useNavigate()

  if (!series || isWebView()) {
    return null
  }

  const handleAddClick = () => {
    if (!series.length) {
      return modal.open(EmptyModal, {
        onCreateClick: () => {
          navigate(routing.memberships.series.create)
        },
      })
    }

    modal.open(SelectSeries, {
      selectedSeries: values.videoSeries,
      onConfirm: (selectedSeries) => {
        setFieldValue(FormFields.videoSeries, selectedSeries)
      },
    })
  }

  const handleRemoveClick = (id: number) => {
    setFieldValue(
      FormFields.videoSeries,
      values.videoSeries?.filter((singleSeries) => singleSeries.id !== id),
    )
  }

  if (values.videoSeries?.length) {
    return (
      <S.Container>
        <S.Buttons>
          Added in {values.videoSeries.length} series
          <ButtonClean
            label="Add to video series"
            withUnderline
            onClick={handleAddClick}
            disabled={disabled}
          />
        </S.Buttons>

        <S.List>
          {values.videoSeries.map((videoSeries) => {
            const singleSeries = series.find((s) => s.id === videoSeries.id)

            if (!singleSeries) {
              return null
            }

            return (
              <S.SeriesListItem>
                <SeriesCell
                  title={singleSeries.title}
                  quantity={singleSeries.episodesCount}
                  thumbnailUrl={singleSeries.coverImage?.url}
                />
                <S.RemoveButton
                  type="button"
                  onClick={() => handleRemoveClick(singleSeries.id)}
                  disabled={disabled}
                >
                  <Icon component={CloseIcon} height={16} />
                </S.RemoveButton>
              </S.SeriesListItem>
            )
          })}
        </S.List>
      </S.Container>
    )
  }

  return (
    <ButtonClean
      label="Add to video series"
      withUnderline
      onClick={handleAddClick}
      disabled={disabled}
    />
  )
}
